




































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Prop} from 'vue-property-decorator';

import {EventBus} from '@/utils/EventBus';

import {NotificationStore} from '@/store/Notification.store';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component
export default class Navigation extends Mixins<BaseComponent>(BaseComponent) {
  private notificationStore: NotificationStore = getModule(NotificationStore, this.$store);

  @Prop({default: false})
  private expanded!: boolean;

  private systemMenu = [
    {
      label: 'Information',
      icon: 'mdi-information',
      route: 'system-info',
    },
    {
      label: 'Regional settings',
      icon: 'mdi-earth',
      route: 'system-region',
    },
    {
      label: 'Resources',
      icon: 'mdi-chart-donut',
      route: 'system-stats',
    },
    {
      label: 'Storage',
      icon: 'mdi-storage',
      route: 'system-storage',
      hidden: true,
    },
    {
      label: 'Update',
      icon: 'mdi-update',
      route: 'system-update',
    },
    {
      label: 'Logs',
      icon: 'mdi-tray-full',
      route: 'system-logs',
    },
  ];

  private networkMenu = [
    {
      label: 'Overview',
      icon: 'mdi-information',
      route: 'network-overview',
    },
    {
      label: 'Ethernet',
      icon: 'mdi-ethernet',
      route: 'network-ethernet',
    },
    {
      label: 'VPN',
      icon: 'mdi-vpn',
      route: 'network-vpn',
    },
    {
      label: 'Security',
      icon: 'mdi-security',
      route: 'network-security',
      disabled: true,
      hidden: true,
    },
    {
      label: 'Advanced',
      icon: 'mdi-cog',
      route: 'network-advanced',
      disabled: true,
      hidden: true,
    },
  ];

  private loraMenu = [
    {
      label: 'Status',
      icon: 'mdi-information',
      route: 'lora-status',
    },
    {
      label: 'Forwarder',
      icon: 'mdi-send',
      route: 'lora-forwarder',
    },
    {
      label: 'Settings',
      icon: 'mdi-cog',
      route: 'lora-settings',
    },
  ];

  private menu = [
    {
      label: 'Dashboard',
      route: 'dashboard',
      icon: 'mdi-view-dashboard',
    },
    {
      label: 'System',
      route: 'system',
      icon: 'mdi-cog',
      children: this.systemMenu,
      expanded: false,
    },
    {
      label: 'Network',
      route: 'network',
      icon: 'mdi-merge',
      children: this.networkMenu,
      expanded: false,
    },
    {
      label: 'LoRa',
      route: 'lora',
      icon: 'mdi-antenna',
      children: this.loraMenu,
      expanded: false,
    },
  ];

  private onNavigationDrawerStateChanged(expanded: boolean) {
    this.$emit('update:expanded', expanded);
  }

  private openNotificationCenter() {
    EventBus.Emit(EventBus.Event.OpenNotificationCenter);
  }

}
